import { AddToCalendarEvent } from './types';

const FpuCalendarCopy: Partial<AddToCalendarEvent>[] = [
  {
    summary: 'Watch FPU Week 1 Lesson',
    description: `Your stress-free, debt-free future is waiting!

This week, you'll learn how to:
•	Follow the 7 Baby Steps
•	Save $1,000 for your starter emergency fund
•	Create and stick to a zero-based budget

Busy day? Stand by your commitment! The fundamentals in this lesson will help you jump-start your financial progress.

You've got this!`,
  },
  {
    summary: 'Watch FPU Week 2 Lesson',
    description: `Get ready for Week 2! This feels like the beginning of a winning streak. ⚡️
This week, you'll learn how to:
•	Live without debt, including credit cards and car payments
•	Pay off all debt (except the house) using the debt snowball
•	Become debt-free in less than two years

Debt is normal—so it's time to get weird! Dive in to one of Dave's favorite lessons right now.`,
  },
  {
    summary: 'Watch FPU Week 3 Lesson',
    description: `Three weeks in a row? Way to keep that momentum going!

This week, you'll learn how to:
•	Avoid the comparison trap
•	Stay debt-free by paying cash for emergencies
•	Save 3-6 months of expenses in a fully funded emergency fund

Get ready to kiss money stress goodbye. It's going to feel awesome.`,
  },
  {
    summary: 'Watch FPU Week 4 Lesson',
    description: `You're unstoppable. Way to keep showing up—even when the calendar (and life) gets messy.

This week, you'll learn how to:
•	Become a Baby Steps Millionaire
•	Save for your children's college fund
•	Pay off your home early
•	Live and give like no one else

Yeah. We said the M-word. You're on your way to becoming a Baby Steps Millionaire!`,
  },
  {
    summary: 'Watch FPU Week 5 Lesson',
    description: `You're almost halfway through Financial Peace University! 🥳 Stick with it. You've got what it takes to cross the finish line.

This week, you'll learn how to:
•	Outsmart marketing tactics trying to bust your budget
•	Gain power over your purchases
•	Become a smart spender

Let your wallet know there's a new sheriff in town! (It's you. You're the sheriff.)`,
  },
  {
    summary: 'Watch FPU Week 6 Lesson',
    description: `Don't lose your focus! This lesson is mission critical. You've got to protect the life and financial future you're working so hard to build.

This week, you'll learn how to:
•	Avoid costly gimmick insurances 
•	Complete your comprehensive insurance plan 
•	Feel protected for life's big curveballs 

Tune in and take good notes. Your peace of mind depends on it!`,
  },
  {
    summary: 'Watch FPU Week 7 Lesson',
    description: `Nice to see you again, hero!

This week, you'll learn how to:
•	Invest 15% of your household income in retirement
•	Diversify across four types of mutual funds
•	Build wealth and retire with dignity

Dare to dream during this lesson. It's important to see where you're headed and how far you've already come!`,
  },
  {
    summary: 'Watch FPU Week 8 Lesson',
    description: `You're in the homestretch! Don't give up! Just two lessons left.

This week, you'll learn how to:
•	Rent, sell and buy a home the right way
•	Avoid bad mortgage options
•	Afford your mortgage payments

Even if you're not in the market for a house right now, learn for later! Because there's no place like home—if you can afford it.`,
  },
  {
    summary: 'Watch FPU Week 9 Lesson',
    description: `Get ready to celebrate! 🎉 You're only one lesson away from finishing Financial Peace University. Don't waste any time—jump right in!

This week, you'll learn how to:
•	Achieve financial peace
•	Change America with generosity
•	Become more of who God created you to be

We're so proud of you. You're about to have everything you need to win with money and change your family tree. Enjoy the sweet taste of victory!`,
  },
];

export { FpuCalendarCopy, AddToCalendarEvent };
